import 'react';
import { embedMarketingTrackingIntoURL } from '@lendi-jam/jam-link';
import Container from '@lendi-ui/container';
import Grid from '@lendi-ui/grid';
import _taggedTemplateLiteral from '@babel/runtime/helpers/esm/taggedTemplateLiteral';
import { py } from '@lendi-ui/spacing';
import styled from 'styled-components';
import { jsx } from 'react/jsx-runtime';

var _templateObject;
var FullWidthImage = styled('img')(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 100%;\n  ", "\n"])), py('lg'));

var ImageWrapper = function ImageWrapper(_ref) {
  var link = _ref.link,
    src = _ref.src,
    alt = _ref.alt;
  return link ? /*#__PURE__*/jsx("a", {
    href: embedMarketingTrackingIntoURL(link),
    children: /*#__PURE__*/jsx(FullWidthImage, {
      src: src,
      alt: alt
    })
  }) : /*#__PURE__*/jsx(FullWidthImage, {
    src: src,
    alt: alt
  });
};
var GenericImage = function GenericImage(_ref2) {
  var src = _ref2.src,
    alt = _ref2.alt,
    _ref2$size = _ref2.size,
    size = _ref2$size === void 0 ? 'md' : _ref2$size,
    link = _ref2.link;
  var sizes = {
    sm: {
      xs: 1,
      sm: 2 / 3,
      md: 1 / 2,
      lg: 2 / 5,
      xl: 1 / 2
    },
    md: {
      xs: 1,
      md: 3 / 4,
      lg: 3 / 5,
      xl: 2 / 3
    },
    lg: {
      xs: 1,
      lg: 4 / 5,
      xl: 5 / 6
    }
  };
  return /*#__PURE__*/jsx(Container, {
    children: /*#__PURE__*/jsx(Grid, {
      halign: "center",
      children: /*#__PURE__*/jsx(Grid.Unit, {
        size: sizes[size],
        children: /*#__PURE__*/jsx(ImageWrapper, {
          src: src,
          alt: alt,
          link: link
        })
      })
    })
  });
};

export { GenericImage as default };
